module.exports = __webpack_public_path__ + "img/brand-left-circle.c582c901.png";